import { Component, ElementRef, OnChanges, Input } from '@angular/core';

declare var MathJax: {
    Hub: {
        Queue: (param: Object[]) => void;
        Config: (param) => void;
    }
};

@Component({
    selector: '[mathJax]',
    template: ''
})
export class MathJaxComponent implements OnChanges {

    @Input() mathJax: string;

    constructor(private element: ElementRef) { }

    ngOnChanges() {
        const de = /{{ '{' }}/gi;

        // If there is space between the text and symbol then it will not be considered as equations.
        const re1 = /\( (.*?) \)/gi;
        const re2 = /\( (.*?)\)/gi;

        const re4 = /\$ (.*?) \$/gi;
        const re5 = /\$ (.*?)\$/gi;
        const re6 = /\$(.*?)\$/gi;

        const re7 = /\` (.*?) \`/gi;
        const re8 = /\` (.*?)\`/gi;

        const pattern1 = this.mathJax && this.mathJax.match(re1);
        const pattern2 = this.mathJax && this.mathJax.match(re2);
        const pattern4 = this.mathJax && this.mathJax.match(re4);
        const pattern5 = this.mathJax && this.mathJax.match(re5);
        const pattern6 = this.mathJax && this.mathJax.match(re6);
        const pattern7 = this.mathJax && this.mathJax.match(re7);
        const pattern8 = this.mathJax && this.mathJax.match(re8);

        if (this.mathJax && this.mathJax.length && this.mathJax.replace) {
            if (pattern1
                || pattern2
                || pattern4
                || pattern5
                || pattern6
                || pattern7
                || pattern8
            ) {
                this.element.nativeElement.innerHTML = this.mathJax;
            } else {
                this.element.nativeElement.innerHTML = !!this.mathJax ? this.mathJax.replace(de, "{") : '';
                MathJax.Hub.Config({ tex2jax: { inlineMath: [['$', '$'], ['`', '`'], ['\\(', '\\)']] } });
                MathJax.Hub.Queue(['Typeset', MathJax.Hub, this.element.nativeElement]);
            }
        } else {
            this.element.nativeElement.innerHTML = '';
        }
    }
}